/* Import React */
import './App.css';

/* Import External components */
import Home from "./screens/Home";
//*IMPORT REACT//*
import { Route, Routes, useLocation } from "react-router-dom";
import { Cgu } from "./screens/Cgu";
import { APropos } from "./screens/APropos";
import { Crew } from "./screens/Crew";

function App() {


    let location = useLocation();
  let backgroundLocation = location.state && location.state.backgroundLocation;
  return (
                <div className="App">

                <Routes location={backgroundLocation || location}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<APropos />} />
                <Route path="/crew" element={<Crew />} />
                <Route path="/Cgu" element={<Cgu />} />
                </Routes>

                </div>


  );
}

export default App;
